// import { useState, useEffect, useCallback } from 'react';
// import { Button, Form, Alert, Card, Tab, Tabs, Spinner } from 'react-bootstrap';
// import { useAuth } from '../context/AuthContext';
// import { useLocation, useNavigate } from 'react-router-dom';

// export default function AuthHandler() {
//   const { login, signup, user, isLoading, logout, token } = useAuth();
//   const navigate = useNavigate();
//   const location = useLocation();

//   const [activeTab, setActiveTab] = useState('login');
//   const [error, setError] = useState({ type: '', message: '' });

//   // Handle redirect on successful login
//   useEffect(() => {
//     if (user && !isLoading) {
//       const redirectPath = location.state?.from?.pathname || '/dashboard';
//       navigate(redirectPath, { replace: true });
//     }
//   }, [user, isLoading, navigate, location.state]);

//   // Handle session expiration
//   useEffect(() => {
//     const sessionExpired = new URLSearchParams(location.search).get('session') === 'expired';
//     if (sessionExpired) {
//       logout();
//       setError({
//         type: 'general',
//         message: 'Your session has expired. Please log in again.'
//       });
//     }
//   }, [location.search, logout]);

//   // Auto-logout on token expiry
//   useEffect(() => {
//     if (!token) return;

//     try {
//       const { exp } = JSON.parse(atob(token.split('.')[1]));
//       const expiryTime = exp * 1000 - Date.now();

//       if (expiryTime <= 0) {
//         logout();
//         return;
//       }

//       const timeout = setTimeout(logout, expiryTime);
//       return () => clearTimeout(timeout);
//     } catch (err) {
//       console.error('Invalid token format:', err);
//       logout();
//     }
//   }, [token, logout]);

//   const clearErrors = useCallback(() => setError({ type: '', message: '' }), []);

//   const handleAuth = async (e, isLogin) => {
//     e.preventDefault();
//     clearErrors();
//     const formData = new FormData(e.target);
//     const credentials = Object.fromEntries(formData.entries());

//     try {
//       if (isLogin) {
//         await login(credentials.email, credentials.password);
//       } else {
//         await signup({
//           displayName: credentials.displayName,
//           email: credentials.email,
//           password: credentials.password,
//           businessName: credentials.businessName,
//         });
//       }
//     } catch (err) {
//       handleAuthErrors(err, isLogin);
//     }
//   };

//   const handleAuthErrors = (err, isLogin) => {
//     // Handle network errors first
//     if (!err.response || err.code === 'ERR_NETWORK') {
//       return setError({ 
//         type: 'general', 
//         message: 'Network error - please check your connection' 
//       });
//     }
  
//     const { status, data } = err.response;
  
//     // Handle login errors
//     if (isLogin) {
//       if (status === 401) {
//         return setError({
//           type: 'credentials',
//           message: 'Invalid email or password'
//         });
//       }
//       return setError({
//         type: 'general',
//         message: data.message || 'Login failed - please try again'
//       });
//     }
  
//     // Handle signup errors
//     if (data?.message?.includes('already exists')) {
//       return setError({
//         type: data.message.includes('email') ? 'email' : 'displayName',
//         message: data.message,
//       });
//     }
    
//     return setError({ 
//       type: 'general', 
//       message: data.message || 'Registration failed' 
//     });
//   };

//   if (isLoading && !user) {
//     return (
//       <div className="d-flex justify-content-center align-items-center vh-100">
//         <div className="text-center">
//           <Spinner animation="border" variant="primary" />
//           <p className="mt-3 text-muted">Loading authentication state...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <Card className="mt-5 mx-auto shadow-sm" style={{ maxWidth: '400px' }}>
//       <Card.Body>
//         <Tabs
//           activeKey={activeTab}
//           onSelect={(k) => {
//             setActiveTab(k);
//             clearErrors();
//           }}
//           className="mb-3"
//         >
//           <Tab eventKey="login" title="Login">
//             <AuthForm
//               type="login"
//               error={error}
//               onSubmit={(e) => handleAuth(e, true)}
//               clearErrors={clearErrors}
//               isSubmitting={isLoading}
//             />
//           </Tab>
//           <Tab eventKey="signup" title="Sign Up">
//             <AuthForm
//               type="signup"
//               error={error}
//               onSubmit={(e) => handleAuth(e, false)}
//               clearErrors={clearErrors}
//               isSubmitting={isLoading}
//             />
//           </Tab>
//         </Tabs>
//         <div className="text-center mt-3">
//           {activeTab === 'login' ? (
//             <span>
//               Don’t have an account?{' '}
//               <Button variant="link" onClick={() => setActiveTab('signup')}>Sign Up</Button>
//             </span>
//           ) : (
//             <span>
//               Already have an account?{' '}
//               <Button variant="link" onClick={() => setActiveTab('login')}>Login</Button>
//             </span>
//           )}
//         </div>
//       </Card.Body>
//     </Card>
//   );
// }

// function AuthForm({ type, error, onSubmit, clearErrors, isSubmitting }) {
//   const isLogin = type === 'login';

//   return (
//     <Form onSubmit={onSubmit}>
//       {/* Unified error display */}
//       {error.message && (
//         <Alert variant="danger" className="mb-3">
//           {error.message}
//         </Alert>
//       )}

//       {!isLogin && (
//         <Form.Group className="mb-3">
//           <Form.Label>Display Name</Form.Label>
//           <Form.Control
//             name="displayName"
//             required
//             isInvalid={error.type === 'displayName'}
//             onChange={clearErrors}
//           />
//           <Form.Control.Feedback type="invalid">{error.message}</Form.Control.Feedback>
//         </Form.Group>
//       )}

//       <Form.Group className="mb-3">
//         <Form.Label>Email</Form.Label>
//         <Form.Control
//           name="email"
//           type="email"
//           required
//           isInvalid={error.type === 'email'}
//           onChange={clearErrors}
//         />
//         <Form.Control.Feedback type="invalid">{error.message}</Form.Control.Feedback>
//       </Form.Group>

//       <Form.Group className="mb-3">
//         <Form.Label>Password</Form.Label>
//         <Form.Control
//           name="password"
//           type="password"
//           required
//           isInvalid={error.type === 'password'}
//           onChange={clearErrors}
//         />
//         <Form.Control.Feedback type="invalid">{error.message}</Form.Control.Feedback>
//       </Form.Group>

//       {!isLogin && (
//         <Form.Group className="mb-3">
//           <Form.Label>Business Name (optional)</Form.Label>
//           <Form.Control name="businessName" />
//         </Form.Group>
//       )}

//       <Button type="submit" className="w-100" disabled={isSubmitting}>
//         {isSubmitting ? <Spinner size="sm" animation="border" /> : isLogin ? 'Login' : 'Create Account'}
//       </Button>
//     </Form>
//   );
// }

import { useState, useEffect, useCallback } from 'react';
import { Button, Form, Alert, Card, Tab, Tabs, Spinner, InputGroup } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';
import { useLocation, useNavigate } from 'react-router-dom';

export default function AuthHandler() {
  const { login, signup, user, isLoading, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const [activeTab, setActiveTab] = useState('login');
  const [error, setError] = useState({ type: '', message: '' });

  useEffect(() => {
    if (user && !isLoading) {
      const redirectPath = location.state?.from?.pathname || '/dashboard';
      navigate(redirectPath, { replace: true });
    }
  }, [user, isLoading, navigate, location.state]);

  useEffect(() => {
    const sessionExpired = new URLSearchParams(location.search).get('session') === 'expired';
    if (sessionExpired) {
      logout();
      setError({
        type: 'general',
        message: 'Your session has expired. Please log in again.'
      });
    }
  }, [location.search, logout]);

  const clearErrors = useCallback(() => setError({ type: '', message: '' }), []);

  const handleAuth = async (e, isLogin) => {
    e.preventDefault();
    clearErrors();

    const formData = new FormData(e.target);
    const credentials = Object.fromEntries(formData.entries());

    if (!credentials.email || !credentials.password || (!isLogin && !credentials.displayName)) {
      return setError({
        type: 'general',
        message: 'Please fill out all required fields.'
      });
    }

    try {
      if (isLogin) {
        await login({ email: credentials.email, password: credentials.password });
      } else {
        await signup({
          displayName: credentials.displayName,
          email: credentials.email,
          password: credentials.password,
          businessName: credentials.businessName,
        });
      }

      navigate('/dashboard', { replace: true });

    } catch (err) {
      handleAuthErrors(err, isLogin);
    }
  };

  const handleAuthErrors = (err, isLogin) => {
    // Handle field-specific validation errors
    if (err.fieldErrors) {
      const firstError = Object.entries(err.fieldErrors)[0];
      return setError({
        type: firstError[0],
        message: firstError[1]
      });
    }
    
    // Handle single field errors
    if (err.field) {
      return setError({
        type: err.field,
        message: err.message
      });
    }
    
    // Handle network errors
    if (!err.response || err.code === 'ERR_NETWORK') {
      return setError({
        type: 'general',
        message: 'Network error – please check your connection'
      });
    }
  
    const { status, data } = err.response;
  
    if (isLogin) {
      if (status === 401) {
        return setError({
          type: 'credentials',
          message: 'Invalid email or password'
        });
      }
      return setError({
        type: 'general',
        message: data.message || 'Login failed – please try again'
      });
    }
  
    // Handle signup errors
    if (status === 400 && data?.message) {
      if (data.message.toLowerCase().includes('email')) {
        return setError({
          type: 'email',
          message: data.message
        });
      }
    }
  
    return setError({
      type: 'general',
      message: data.message || 'Registration failed'
    });
  };

  if (isLoading && !user) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="text-center">
          <Spinner animation="border" variant="primary" />
          <p className="mt-3 text-muted">Loading authentication state...</p>
        </div>
      </div>
    );
  }

  return (
    <Card className="mt-5 mx-auto shadow-sm" style={{ maxWidth: '400px' }}>
      <Card.Body>
        <Tabs
          activeKey={activeTab}
          onSelect={(k) => {
            setActiveTab(k);
            clearErrors();
          }}
          className="mb-3"
        >
          <Tab eventKey="login" title="Login">
            <AuthForm
              type="login"
              error={error}
              onSubmit={(e) => handleAuth(e, true)}
              clearErrors={clearErrors}
              isSubmitting={isLoading}
            />
          </Tab>
          <Tab eventKey="signup" title="Sign Up">
            <AuthForm
              type="signup"
              error={error}
              onSubmit={(e) => handleAuth(e, false)}
              clearErrors={clearErrors}
              isSubmitting={isLoading}
            />
          </Tab>
        </Tabs>
        <div className="text-center mt-3">
          {activeTab === 'login' ? (
            <span>
              Don’t have an account?{' '}
              <Button variant="link" onClick={() => setActiveTab('signup')}>Sign Up</Button>
            </span>
          ) : (
            <span>
              Already have an account?{' '}
              <Button variant="link" onClick={() => setActiveTab('login')}>Login</Button>
            </span>
          )}
        </div>
      </Card.Body>
    </Card>
  );
}

function AuthForm({ type, error, onSubmit, clearErrors, isSubmitting }) {
  const isLogin = type === 'login';
  const [showPassword, setShowPassword] = useState(false);

  return (
    <Form onSubmit={onSubmit} noValidate>
      {error.message && (
        <Alert 
          variant="danger" 
          className="mb-3"
          onClose={clearErrors}
          dismissible
        >
          {error.message}
        </Alert>
      )}

      {!isLogin && (
        <Form.Group className="mb-3" controlId="displayName">
          <Form.Label>Display Name</Form.Label>
          <Form.Control
            name="displayName"
            required
            autoFocus
            isInvalid={error.type === 'displayName'}
            onChange={clearErrors}
          />
          <Form.Control.Feedback type="invalid">
            {error.type === 'displayName' ? error.message : ''}
          </Form.Control.Feedback>
        </Form.Group>
      )}

<Form.Group className="mb-3" controlId="email">
  <Form.Label>Email</Form.Label>
  <Form.Control
    name="email"
    type="email"
    required
    autoFocus={isLogin}
    isInvalid={error.type === 'email' || error.type === 'credentials'}
    onChange={clearErrors}
  />
  <Form.Control.Feedback type="invalid">{error.message}</Form.Control.Feedback>
</Form.Group>
      <Form.Group className="mb-3" controlId="password">
        <Form.Label>Password</Form.Label>
        <InputGroup>
          <Form.Control
            name="password"
            type={showPassword ? 'text' : 'password'}
            required
            isInvalid={error.type === 'password' || error.type === 'credentials'}
            onChange={clearErrors}
          />
          <Button
            variant="outline-secondary"
            type="button"
            onClick={() => setShowPassword((prev) => !prev)}
          >
            {showPassword ? 'Hide' : 'Show'}
          </Button>
          <Form.Control.Feedback type="invalid">{error.message}</Form.Control.Feedback>
        </InputGroup>
      </Form.Group>

      {!isLogin && (
        <Form.Group className="mb-3" controlId="businessName">
          <Form.Label>Business Name (optional)</Form.Label>
          <Form.Control name="businessName" />
        </Form.Group>
      )}

      <Button type="submit" className="w-100" disabled={isSubmitting}>
        {isSubmitting ? <Spinner size="sm" animation="border" /> : isLogin ? 'Login' : 'Create Account'}
      </Button>
    </Form>
  );
}
